import { render, staticRenderFns } from "./PatientInforConfirmModal.vue?vue&type=template&id=35d50a52&scoped=true"
import script from "./PatientInforConfirmModal.vue?vue&type=script&lang=js"
export * from "./PatientInforConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./PatientInforConfirmModal.vue?vue&type=style&index=0&id=35d50a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d50a52",
  null
  
)

export default component.exports